import { useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "@mui/material";
import PasswordField from "../PasswordField";
import { validateChangePasswordForm } from "../../utils/authForms";
import { changePassword } from "../../redux/asyncThunk/userActions";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    background: "#fff",
  },
};

export default function ProfileChangePassword({ userId }) {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { id, value } = event.target;
    setForm((prev) => ({ ...prev, [id]: value }));
    setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const nextErrors = validateChangePasswordForm(form);
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }

    setIsSubmitting(true);

    try {
      await dispatch(
        changePassword({
          userId,
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
        })
      ).unwrap();

      setForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setErrors({});
    } catch {
      // сообщение уходит в redux messages
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="app-profile-form app-profile-form--compact" onSubmit={handleSubmit}>
      <PasswordField
        id="currentPassword"
        label="Текущий пароль"
        fullWidth
        size="small"
        value={form.currentPassword}
        onChange={handleChange}
        error={Boolean(errors.currentPassword)}
        helperText={errors.currentPassword}
        sx={fieldSx}
        autoComplete="current-password"
      />

      <PasswordField
        id="newPassword"
        label="Новый пароль"
        fullWidth
        size="small"
        value={form.newPassword}
        onChange={handleChange}
        error={Boolean(errors.newPassword)}
        helperText={errors.newPassword}
        sx={fieldSx}
        autoComplete="new-password"
      />

      <PasswordField
        id="confirmPassword"
        label="Повторите пароль"
        fullWidth
        size="small"
        value={form.confirmPassword}
        onChange={handleChange}
        error={Boolean(errors.confirmPassword)}
        helperText={errors.confirmPassword}
        sx={fieldSx}
        autoComplete="new-password"
      />

      <div className="app-profile-form__actions">
        <Button
          type="submit"
          variant="contained"
          size="small"
          disabled={isSubmitting}
          className="app-btn app-btn--primary app-btn--compact"
        >
          {isSubmitting ? "Сохранение…" : "Сменить пароль"}
        </Button>
      </div>
    </form>
  );
}
